(function () {
  'use strict';

  const SCROLL_CONTAINER = '.mobile-nav__body';
  const ACCORDION_HEADER = '[js-accordion-header]';
  const ACCORDION_ITEM = '[js-accordion-item]';
  const ACCORDION_CONTENT = '[js-accordion-content]';
  const ACCORDION_WRAPPER = '.accordion-item-header';

  const BORDER_OPEN = 'border-black';
  const BORDER_CLOSED = 'border-gray-200';

  const MAX_FOLLOW_MS = 1600;
  const GAP = 16;
  const SMOOTHING = 0.14;
  const FRAME_MS = 1000 / 60;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function collapse(header) {
    header.setAttribute('aria-expanded', 'false');

    const content = header
      .closest(ACCORDION_ITEM)
      ?.querySelector(ACCORDION_CONTENT);

    if (content) {
      content.setAttribute('aria-hidden', 'true');
      content.setAttribute('inert', 'true');
    }

    const wrapper = header.closest(ACCORDION_WRAPPER);
    if (wrapper) {
      wrapper.classList.remove(BORDER_OPEN);
      wrapper.classList.add(BORDER_CLOSED);
    }
  }

  function collapseOthers(container, opening) {
    container
      .querySelectorAll(ACCORDION_HEADER + '[aria-expanded="true"]')
      .forEach(function (header) {
        if (header !== opening) collapse(header);
      });
  }

  function followExpansion(container, item, anchorTop) {
    const startedAt = performance.now();
    const smoothing = prefersReducedMotion() ? 1 : SMOOTHING;
    const safeArea =
      parseFloat(window.getComputedStyle(container).paddingBottom) || 0;

    let lastFrameAt = startedAt;
    let top = anchorTop;
    let aborted = false;

    function abort() {
      aborted = true;
    }

    container.addEventListener('wheel', abort, { passive: true });
    container.addEventListener('touchstart', abort, { passive: true });

    function cleanup() {
      container.removeEventListener('wheel', abort);
      container.removeEventListener('touchstart', abort);
    }

    function frame(now) {
      if (aborted) return cleanup();

      const containerBox = container.getBoundingClientRect();

      const shift = item.getBoundingClientRect().top - containerBox.top - top;
      container.scrollTop += shift;

      const itemBox = item.getBoundingClientRect();
      const delta = Math.min(
        itemBox.bottom + GAP - (containerBox.bottom - safeArea),
        itemBox.top - containerBox.top
      );

      const dt = Math.max(now - lastFrameAt, 1);
      lastFrameAt = now;

      if (delta > 0) {
        container.scrollTop += delta * (1 - Math.pow(1 - smoothing, dt / FRAME_MS));
      }

      top = item.getBoundingClientRect().top - containerBox.top;

      if (now - startedAt > MAX_FOLLOW_MS) return cleanup();

      window.requestAnimationFrame(frame);
    }

    window.requestAnimationFrame(frame);
  }

  function handleAccordionClick(event) {
    const header = event.target.closest?.(ACCORDION_HEADER);
    if (!header || header.getAttribute('aria-expanded') !== 'false') return;

    const container = header.closest(SCROLL_CONTAINER);
    const item = header.closest(ACCORDION_ITEM);
    if (!container || !item) return;

    const anchorTop =
      item.getBoundingClientRect().top - container.getBoundingClientRect().top;

    collapseOthers(container, header);
    followExpansion(container, item, anchorTop);
  }

  document.addEventListener('click', handleAccordionClick, true);
})();
